$('.slider-chill').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
responsive: [
  {
    breakpoint: 768,
    settings: {
    slidesToShow: 1,
    centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
    slidesToScroll: 1
    }
  }
  ]
});

$(".prev-btn").click(function () {
    $(".slider-chill").slick("slickPrev");
    $(".slider-users").slick("slickPrev");
});

$(".next-btn").click(function () {
    $(".slider-chill").slick("slickNext");
    $(".slider-users").slick("slickNext");
});

$('.slider-users').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
responsive: [
  {
    breakpoint: 768,
    settings: {
    slidesToShow: 1,
    centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
    slidesToScroll: 1
    }
  }
  ]
});
